import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import EaFeatureDev from '@propertypal/shared/src/resources/icons/products/dev-featured-icon.svg';
import EaMicrosites from '@propertypal/shared/src/resources/icons/products/dev-microsites-icon.svg';
import EaPromotion from '@propertypal/shared/src/resources/icons/products/dev-social-media-icon.svg';
import EaBranding from '@propertypal/shared/src/resources/icons/products/ea-branding-icon.svg';
import EaConsultancy from '@propertypal/shared/src/resources/icons/products/ea-consultancy-icon.svg';
import EaDisplayAds from '@propertypal/shared/src/resources/icons/products/ea-display-ads-icon.svg';
import EaTakeover from '@propertypal/shared/src/resources/icons/products/ea-homepage-takeover-icon.svg';
import EaListing from '@propertypal/shared/src/resources/icons/products/ea-listing-icon.svg';
import EaSponsor from '@propertypal/shared/src/resources/icons/products/ea-sponsor-search-icon.svg';
import EaSuperFeature from '@propertypal/shared/src/resources/icons/products/ea-superfeatured-homepage-icon.svg';
import EaWebsite from '@propertypal/shared/src/resources/icons/products/ea-websites-icon.svg';
import EaPaid from '@propertypal/shared/src/resources/icons/products/paid-social-media-icon.svg';
import Link from 'next/link';
import React from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Heading, Text } from '../typography';
import { ProductsContent } from './ProductsContent.style';
import { ProductsGrid, AgentsGridItem, ProductsBadge, ProductBadge } from './ProductsGrid.style';
import { WhyHeading } from './WhyPropertyPalContent.style';

type Icon = {
  SVG: string;
  heading: string;
  text: string;
  maxW?: number;
  href: string;
  badge?: ProductsBadge;
};

const PRODUCTS_URL = '/products/developers';

const icons: Icon[] = [
  {
    SVG: EaListing,
    heading: 'Listing a Development',
    text: `List your development on Northern Ireland's largest property website.`,
    maxW: 330,
    href: `${PRODUCTS_URL}/listing-a-development`,
  },
  {
    SVG: EaMicrosites,
    heading: 'Development Microsites',
    text: `Microsites are custom built 'mini-websites' within PropertyPal's main website.`,
    href: '/development-microsites',
  },
  {
    SVG: EaSponsor,
    heading: 'Sponsor a Search',
    text: 'Showcase your brand and key message in front of thousands of potential buyers.',
    maxW: 350,
    href: `${PRODUCTS_URL}/sponsor-a-search`,
  },
  {
    SVG: EaDisplayAds,
    heading: 'Display Advertising',
    text: `Get your development seen by Northern Ireland's largest property audience.`,
    href: `${PRODUCTS_URL}/display-advertising`,
  },
  {
    SVG: EaPaid,
    heading: 'Paid Social Media Advertising',
    text: 'Reach a wider audience and not just those who follow PropertyPal.',
    maxW: 310,
    href: `${PRODUCTS_URL}/paid-social-media-advertising`,
  },
  {
    SVG: EaConsultancy,
    heading: 'Specialist Consultancy',
    text: 'Expertise and insight, driven by rigorous analysis and sectoral knowledge.',
    href: `${PRODUCTS_URL}/specialist-consultancy`,
  },
  {
    SVG: EaWebsite,
    heading: 'Developer Websites',
    text: `Latest cutting-edge websites using PropertyPal's technology.`,
    href: `${PRODUCTS_URL}/developer-websites`,
  },
  {
    SVG: EaBranding,
    heading: 'Branding',
    text: 'Full service solution for marketing your business.',
    maxW: 290,
    href: `${PRODUCTS_URL}/branding`,
  },
  {
    SVG: EaFeatureDev,
    heading: 'Featured Development',
    text: 'Feature a development with a more prominent listing and additional photos.',
    maxW: 340,
    href: `${PRODUCTS_URL}/featured-development`,
  },
  {
    SVG: EaPromotion,
    heading: 'Promotion on Social Media',
    text: `Reach PropertyPal's active social media audience across multiple platforms.`,
    href: `${PRODUCTS_URL}/promotion-on-social-media`,
  },
  {
    SVG: EaTakeover,
    heading: 'Homepage Takeover',
    text: `Take pride of place on the PropertyPal homepage.`,
    maxW: 200,
    href: `${PRODUCTS_URL}/homepage-takeover`,
  },
  {
    SVG: EaSuperFeature,
    heading: 'Superfeatured Homepage',
    text: 'Showcase developments on the PropertyPal Homepage and in the New Homes section.',
    href: `${PRODUCTS_URL}/superfeatured-homepage`,
  },
];

const DevelopersContent = () => {
  return (
    <ProductsContent>
      <WhyHeading align="center" mb={65} fontSize={36}>
        Developers
      </WhyHeading>
      <ProductsGrid>
        {icons.map(({ SVG, heading, text, maxW, href, badge }) => (
          <AgentsGridItem key={heading} maxW={maxW}>
            <div>
              <SVG />
              <div>
                <Heading>{heading}</Heading>
                <Text>{text}</Text>
              </div>
            </div>
            {href && (
              <Link prefetch={false} href={href}>
                <span>Find out more</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </Link>
            )}
            {badge && (
              <ProductBadge color={badge.color}>
                <span className="badge-title">{badge.title}</span>
                <span className="badge-text">{badge.text}</span>
              </ProductBadge>
            )}
          </AgentsGridItem>
        ))}
      </ProductsGrid>
    </ProductsContent>
  );
};

export default DevelopersContent;
